<template>
    <div class="flex flex-col h-full" v-if="order.number">
        <div class="flex flex-row justify-between mb-6 mt-1">
            <div class="flex flex-row items-center">
                <router-link class="text-3xl font-semibold text-gray-900 -mt-1" tag="a" :to="{ name: 'orders' }">
                    {{ $t('orders.listing.pageTitle') }}
                </router-link>

                <h3 class="text-xl text-gray-500 mx-3">
                    >
                </h3>

                <h3 class="text-xl text-gray-500">
                    #{{ order.number }}
                </h3>
            </div>

            <div class="flex flex-row space-x-2 items-center">
                <span class="text-sm bg-blue-200 px-3 py-1 rounded">
                    {{ $t(`global.status.${order.status}`) }}
                </span>

                <span class="text-sm bg-blue-200 px-3 py-1 rounded">
                    {{ formatDateTime(order.created_at) }}
                </span>
            </div>
        </div>

        <template v-if="order.id">
            <activation-form :selected-order.sync="order" ref="activationForm" v-if="hasLicensesToActivate" />

            <div class="mt-10 pt-6 border-t border-gray-200" v-if="hasLicensesToActivate" />

            <activations-history :order="order" />
        </template>

        <license-modal @closed="focusSerialField()" />
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import ActivationForm from '@/components/Activation/ActivationForm.vue';
    import ActivationsHistory from '@/components/Activation/ActivationsHistory.vue';
    import LicenseModal from '@/components/Activation/LicenseModal.vue';

    export default {
        components: {
            ActivationsHistory,
            ActivationForm,
            LicenseModal,
        },

        data() {
            return {
                order: {},
            };
        },

        computed: {
            hasLicensesToActivate() {
                return this.order.licenses
                    .filter(license => !license.activation_date)
                    .length;
            },
        },

        methods: {
            ...mapActions([
                'getOrder',
            ]),

            async fetch() {
                this.$wait.start('fetching.order');

                try {
                    const response = await this.$axios.get(`orders/${this.$route.params.id}`);

                    this.order = response.data.data;
                } catch (error) {
                    // this.$notify.show({
                    //     type: 'error',
                    //     message: this.$t('campaigns.listing.errors.fetching'),
                    // });
                    console.log('Error fetching order');

                    throw error;
                } finally {
                    this.$wait.end('fetching.order');
                }
            },

            focusSerialField() {
                if (!this.$refs.activationForm) {
                    return;
                }

                this.$refs.activationForm.focusAfsSerialField();
            },
        },

        created() {
            this.fetch();
        },
    };
</script>
